export const CIRCULAR_GRID = "circular_grid";
export const SQUARE_GRID = "square_grid";
export const LARGE_BANNER = "large_banner";
export const SQUARE_BANNER = "square_banner";
export const SAMLL_BANNER = "small_banner";
export const HORIZONTAL_SQUARE = "horizontal_square";